import { render, staticRenderFns } from "./InfoTab.vue?vue&type=template&id=9abf3d62&"
import script from "./InfoTab.vue?vue&type=script&lang=ts&"
export * from "./InfoTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports